import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=52c250b7&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QTable,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QTable,QBtn})
